export function labels(state = { }, action) {
	switch (action.type) {
		case 'FETCH_LABELS_SUCCESS': {
			const newState = { ...state }
			const newData = (action.payload || {}).data
			const locale = (action.payload || {}).locale || 'default'
			if (newData) {
				newState[locale] = newData
			}
			return {
				...newState
			}
		}
	}
	return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetchLabelsReducer.js